export enum PrivacyPolicyTranslations {
  privacyPolicyHtml = 'privacyPolicy.privacyPolicyHtml',
}
